import { createFileRoute } from '@tanstack/react-router';

// const CustomerGeneralSettingsView = React.lazy(
//   () => import('@/modules/backoffice/customers/pages/CustomerGeneralSettings'),
// );

export const Route = createFileRoute(
  '/_authenticated/backoffice/customers/$customerId/general',
)({
  head: () => ({
    meta: [{ title: 'Informações Gerais do Cliente' }],
  }),
  component: function Component() {
    // const { customerId } = Route.useParams();

    return <div />;

    // return <CustomerGeneralSettingsView customerId={customerId} />;
  },
});
